module.exports = __webpack_public_path__ + "img/logo.4c1a8212.png";